import { combineReducers } from "redux";

import agencyReducer from "./agency/reducer";
import apiErrorReducer from "./apiError/reducer";
import campaignToCreateReducer from "./campaignToCreate/reducer";
import sessionReducer from "./session";
import userReducer from "./user";
import { ReduxApplicationState } from "../../types/ReduxTypes/ReduxApplicationState";

const rootReducer = () =>
  combineReducers<ReduxApplicationState>({
    agency: agencyReducer,
    campaignToCreate: campaignToCreateReducer,
    session: sessionReducer,
    user: userReducer,
    apiError: apiErrorReducer,
  });

export default rootReducer;
